import React, { FC, memo, useMemo } from 'react';
import { useLocation } from 'react-router';

import { useAccountModal } from '@rainbow-me/rainbowkit';

import { useAuth } from '@contexts/common/AuthorizationContext';

import { isAddressesEqual } from '@utils/tokens.utils';

import logo from '@assets/logos/logo.png';

import Button from '@components/common/Button';
import Container from '@components/common/Container';
import Link from '@components/common/Link';

import { ADMINS_LIST_ADDRESS } from '@constants/common/common.constants';
import { HEADER_ROUTES } from '@constants/common/menu.constants';
import { PATH_ADMIN } from '@constants/common/routes.constants';

import useStyles from '../styles.module';

const HeaderContainer: FC = () => {
  const { classes } = useStyles();
  const { account } = useAuth();
  const { pathname } = useLocation();
  const { openAccountModal } = useAccountModal();

  const isAdmin = useMemo(
    () => ADMINS_LIST_ADDRESS.find((item) => isAddressesEqual(account, item)),
    [account],
  );

  const renderNavButtons = useMemo(
    () =>
      HEADER_ROUTES.map(({ title, href, isNewTab }) => {
        const isActive = href === pathname;

        if (href === PATH_ADMIN && !isAdmin) return null;

        return (
          <Link
            key={title}
            variant="subtitle1"
            pathname={href}
            isNewTab={isNewTab}
            color={(theme) => theme.palette.custom.text.light}
            activeColor={(theme) => theme.palette.custom.text.active}
            isActive={isActive}
          >
            {title}
          </Link>
        );
      }),
    [pathname, isAdmin],
  );

  return (
    <div className={classes.header}>
      <Container className={classes.row}>
        <div className={classes.inner}>
          <nav className={classes.nav}>{renderNavButtons}</nav>
        </div>
        <div className={classes.buttonWrap}>
          {/* <img src={logo} alt="" className={classes.logo} /> */}
          {account ? (
            <Button onClick={openAccountModal}>My wallet</Button>
          ) : (
            <Button checkAuth>Connect Wallet</Button>
          )}
        </div>
      </Container>
    </div>
  );
};

export default memo(HeaderContainer);
